import React, { useRef } from 'react'
import { useInView } from "framer-motion"

import ContentfulLongText from '../../ContentfulLongText'

import './accessories.css'

export const Accessories = ({ accessories }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    if(accessories) {
        return (
            <div ref={ref} className="text-center accessories" style={{ 
                backgroundImage: `url(${accessories.backgroundMedia})`, 
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }}>
                <div style={{
                    opacity: isInView ? 1 : 0,
                    transition: `all .5s cubic-bezier(0.17, 0.55, 0.55, 1) .5s`
                }}>
                    <h2 className='mt-0 mb-10' >{accessories.title}</h2>
                    <ContentfulLongText longTextContent={accessories.content.content} />
                    <a href='/contact/' className="mt-0 mb-0 btn btn-brand-color-linear btn-link-linear">GET In TOUCH</a>
                </div>
                <div className="grid col-4 gap-5 lists">
                    {accessories.images.map((item, index)=> (
                        <div key={index} className="item" style={{
                            animation: `float 6s ease-in-out infinite`, 
                            animationDelay: `${index * .9}s`,
                            opacity: isInView ? 1 : 0,
                            transition: `all ${.9 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.9 * index}s`
                        }}>
                            <img className='mb-0' src={item.gatsbyImageData.images.fallback.src} alt={accessories.title || `Accessories Media ${index}`} />
                        </div>
                    ))}
                </div>
            </div>
        )
    } else return null
}